/** Records an intentionally recoverable browser failure before fallback. */
export function reportRecoverableError(context: string, error: unknown): void {
  // eslint-disable-next-line no-console -- diagnostics are required so fallback paths remain traceable
  console.debug(`[SafheNet] ${context}`, error)
}
